/** Scrolls a focused field into the visible area on narrow viewports (virtual keyboard). */
export function scrollLoginFieldIntoView(element: HTMLElement): void {
  if (typeof window === "undefined") return;
  if (!window.matchMedia("(max-width: 639px)").matches) return;

  requestAnimationFrame(() => {
    element.scrollIntoView({ block: "center", behavior: "smooth" });
  });
}
